import AddChild from "./AddChild";
import React, { useState, useEffect, useContext } from "react";
import AppState from "../../context/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import EditChild from "./EditChild";
import DeleteChild from "./DeleteChild";
import ListChildAndGifts from "./ListChildAndGifts";
import { useNavigate } from "react-router-dom";
import LetterToSanta from '../HelpButtons/LetterToSantaHelp'

const LetterToSantaParent = () => {
  const context = useContext(AppState);
  const navigate = useNavigate();
  const auth = JSON.parse(sessionStorage.getItem("user"));
  let [viewed, setViewed] = useState([]);
  const [showAddChild, setShowAddChild] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [showDeleteChild, setShowDeleteChild] = useState(false);
  const [showChildGifts, setShowChildGifts] = useState(false);
  useEffect( () => {
   if(context.store.parentMode === false){
     navigate("/letter-to-santa-child")
   }
  }, [ context.store.parentMode, navigate ] );

  useEffect(() => {
    const fetchData = async () => {
      await context.getChildren(auth.user._id).then((data) => {
        data.children.map(async (child, i) => {
          let formattedObj = {
            list: [],
            name: child.name,
            age: child.age,
            uid: child.childUid,
          };
          await context.getChildGiftList(child.childUid).then((listData) => {
            if (listData[0]) {
              listData[0].gifts.map((gift, i) => {
                if (gift.gift) {
                  formattedObj.list.push(gift.gift);
                  return gift.gift;
                }
                return undefined;
              });
            }
          });
          viewed.push(formattedObj);
          setViewed(viewed);
          context.store.children = viewed;
          context.setStore({
            ...context.store,
          });
        });
      });
    };
    fetchData();
    // eslint-disable-next-line
  }, []);
  const addChildForm = (event) => {
    event.preventDefault();
    setShowAddChild(true);
    context.setStore({
      ...context.store,
      addForm: true,
    });
  };
  const createList = (event) => {
    event.preventDefault();
    context.store.currentChild = event.currentTarget.getAttribute("uid");
    context.store.parentMode = false;
    context.setStore({
      ...context.store,
    });
    navigate("/letter-to-santa-child")
  };
  const handleAddChildClose = () => {
    setShowAddChild(false);
  };
  function handleDeleteChild(event) {
    setShowDeleteChild(true);
    context.store.addDelete = true;
    context.store.currentChild = event.currentTarget.getAttribute("uid");
    context.store.currentChildName =
      event.currentTarget.getAttribute("childname");
    context.setStore({
      ...context.store,
    });
  }
  function handleDeleteChildClose() {
    setShowDeleteChild(false);
  }
  function handleEditChild(event) {
    event.preventDefault();
    setEditModalOpen(true);
    context.store.addEdit = true;
    context.store.currentChild = event.currentTarget.getAttribute("uid");
    context.setStore({
      ...context.store,
    });
  }
  function handleEditChildClose() {
    setEditModalOpen(false);
  }
  const handleShowList = (event) => {
    context.store.currentChildName = event.currentTarget.getAttribute("uid");
    context.setStore({
      ...context.store,
    });
    setShowChildGifts(true);
    navigate("/letter-to-santa-parent-list");
  };
  return (
    <div>
      <LetterToSanta/>
      <h1 className="my-5">
        <u>Parent Mode</u>
      </h1>
      <div className="">
        <div className="col d-flex flex-column aling-items-center justify-content-center">

        </div>
        <div className="col">
          <h3>Manage Children</h3>
          <div className="childrenDiv">
            <div className="row row-cols-2">
              {context.store.children.length > 0 ? (
                context.store.children.map((v, i) => {
                  return (
                    <div
                      key={i}
                      className="d-flex justify-content-center childAndButton"
                    >
                      <div className="col m-2">
                        <p>{v.name}</p>
                        {v.list.length > 0 ? (
                          <div className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ display: "flex" }}>
                              <button uid={v.name} onClick={handleShowList}>
                                View List
                              </button>
                              &nbsp;
                              <button uid={v.uid} onClick={handleEditChild}>
                                <FontAwesomeIcon icon={faEdit} />
                              </button>
                              &nbsp;
                              <button
                                uid={v.uid}
                                childname={v.name}
                                onClick={handleDeleteChild}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ display: "flex" }}>
                              <button uid={v.uid} onClick={createList}>
                                Create List
                              </button>
                              <button uid={v.uid} onClick={handleEditChild}>
                                <FontAwesomeIcon icon={faEdit} />
                              </button>
                              <button
                                uid={v.uid}
                                childname={v.name}
                                onClick={handleDeleteChild}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div></div>
              )}
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center my-2">
              <button className="christmasButtonLetter" onClick={addChildForm}>
                Add Child
              </button>
            </div>
            {context.store.addForm ? (
              <AddChild open={showAddChild} handleClose={handleAddChildClose} />
            ) : (
              ""
            )}
            {context.store.addEdit ? (
              <EditChild
                open={editModalOpen}
                uid={context.store.currentChild}
                handleClose={handleEditChildClose}
              />
            ) : (
              ""
            )}
            {context.store.addDelete ? (
              <DeleteChild
                open={showDeleteChild}
                uid={context.store.currentChild}
                handleClose={handleDeleteChildClose}
              />
            ) : (
              ""
            )}
            {showChildGifts ? <ListChildAndGifts /> : ""}
          </div>
        </div>
      </div>
    </div>
  );
};
export default LetterToSantaParent;
